var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, ElementRef } from '@angular/core';
import { AbstractModalContentComponent } from '../modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';
var SlideshowComponent = /** @class */ (function (_super) {
    __extends(SlideshowComponent, _super);
    function SlideshowComponent(modalService) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.TYPE = 'full';
        return _this;
    }
    SlideshowComponent.prototype.ngOnInit = function () {
        var imgParams = this.data[0];
        var selectedIndex = this.data[1] ? this.data[1] : 0;
        if (imgParams && imgParams.length) {
            this.processImages(imgParams, selectedIndex);
        }
    };
    SlideshowComponent.prototype.selectImage = function (img, index, label) {
        this.selected = { val: img, pos: index, label: label };
    };
    SlideshowComponent.prototype.selectImageStyle = function () {
        return "url('" + this.selected.val + "');";
    };
    SlideshowComponent.prototype.selectNext = function () {
        var el = this.$imageScroll.nativeElement;
        var curr = this.selected.pos;
        if (window.innerWidth <= 600) {
            if ((curr + 1) === this.srcs.length) {
                el.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }
            else {
                el.scrollTo({ left: el.scrollLeft + el.offsetWidth / 4, top: 0, behavior: 'smooth' });
            }
        }
        curr = (curr + 1) % this.srcs.length;
        this.selected = { val: this.srcs[curr]['src'], pos: curr, label: this.srcs[curr]['label'] };
    };
    SlideshowComponent.prototype.selectPrevious = function () {
        var el = this.$imageScroll.nativeElement;
        var curr = this.selected.pos;
        if (window.innerWidth <= 600) {
            if (curr === 0) {
                el.scrollTo({ left: el.scrollLeft + el.offsetWidth * this.srcs.length, top: 0, behavior: 'smooth' });
            }
            else {
                el.scrollTo({ left: el.scrollLeft - el.offsetWidth / 4, top: 0, behavior: 'smooth' });
            }
        }
        curr = curr === 0 ? this.srcs.length - 1 : curr - 1;
        this.selected = { val: this.srcs[curr]['src'], pos: curr, label: this.srcs[curr]['label'] };
    };
    SlideshowComponent.prototype.processImages = function (images, index) {
        if (index === void 0) { index = 0; }
        if (images.constructor != Array) {
            images = Object.assign(new Array(), [images]);
        }
        this.srcs = images;
        this.selected = { val: images[index]['src'], pos: index, label: images[index]['label'] };
    };
    /**
     * Keyboard listener
     * Navigate on autocomlete using keyboard
     */
    SlideshowComponent.prototype.handleKeyboardEvent = function (event) {
        event.stopPropagation();
        switch (event.key) {
            case 'ArrowLeft':
                this.selectPrevious();
                break;
            case 'ArrowRight':
                this.selectNext();
                break;
            default:
                return;
        }
    };
    return SlideshowComponent;
}(AbstractModalContentComponent));
export { SlideshowComponent };
